import DefaultContentTemplateEmbedded from '@/components/DefaultContentTemplate/Embedded';
import { useReflectionVideosStore } from '../../store/useSearchStore';
import { SuspenseLoading } from '@/pages/reporting-tools/components/loading';

export const Results = ({ loading }: { loading: boolean }) => {
  const reflections = useReflectionVideosStore((state) => state.page.page?.reflections);
  const page = useReflectionVideosStore((state) => state.page.page);

  return (
    <>
      <h1 className="mt-sh-30 font-cadiz text-sh-28-32 font-bold">{page?.yourResultsLabel}</h1>

      <div className={`${loading ? 'opacity-50' : ''} relative`}>
        {loading && <SuspenseLoading className="!h-full !items-start !justify-center" />}

        {reflections?.map((reflection) => (
          <div key={reflection?.id} className="mb-sh-60">
            <div className="grid grid-cols-1 gap-sh-30 md:grid-cols-2">
              {reflection?.videos?.map((video) => (
                <div key={video?.id} className="col-span-1">
                  <h2 className="mt-sh-30 font-cadiz text-sh-28-32 font-bold">{video?.title}</h2>
                  <p className="mb-sh-15 font-cadiz text-sh-xs">{video?.description}</p>

                  <DefaultContentTemplateEmbedded
                    className="reflection-video !my-0 w-full"
                    fitContent
                    // @ts-expect-error DEPRECATED_STRAPI_ATTRIBUTES
                    component={{
                      id: 'DefaultContentTemplateEmbedded',
                      link: video?.video || '',
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};
